import api from "../../lib/api";
import { toast } from "react-toastify";
import { fetchPropertyByRealId } from "./propertyActions";

const apiRoute = `/api/agent`;

export const getAllAgents = () => (dispatch) => {
  return api
    .get(`${apiRoute}/agents`)
    .then((res) => {
      dispatch({
        type: "GET_ADMIN_AGENTS",
        payload: res.data.data,
      });
    })
    .catch((err) => err);
};

export const logRecommendation = (values) => (dispatch) => {
  return api
    .post(`${apiRoute}/logger/recommends`, {
      ...values,
    })
    .then((res) => {
      dispatch({
        type: "LOG_EVENT_RECOMMENDATION",
        payload: res.data.data,
      });
      dispatch(fetchPropertyByRealId(values.codeId));
    })
    .catch((err) => {
      if (err.response?.data?.message) {
        toast.error(err.response.data.message);
      }
      throw err;
    });
};

export const addImages =
  (id, values, codeId, onProgress) => async (dispatch) => {
    const files = Array.from(values);
    const total = files.length;

    try {
      const formData = new FormData();

      for (let i = 0; i < files.length; i++) {
        formData.append("images[]", files[i]);
      }

      await api.post(`${apiRoute}/properties/images/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          if (onProgress) {
            const percentage = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total,
            );
            onProgress({
              uploaded: Math.round((percentage / 100) * total),
              total,
              percentage,
            });
          }
        },
      });

      return { success: true };
    } catch (err) {
      toast.error("Greška u dodavanju slika");
      throw err;
    }
  };

export const checkImageProcessingStatus =
  (propertyId, total, existing = 0) =>
  async () => {
    try {
      const res = await api.get(
        `${apiRoute}/properties/images/${propertyId}/status?total=${total}&existing=${existing}`
      );
      return res.data;
    } catch (err) {
      console.error("Error checking image processing status:", err);
      throw err;
    }
  };

export const rotateImage = (imageId, propertyId, data) => async (dispatch) => {
  try {
    const res = await api.put(
      `${apiRoute}/properties/image/${imageId}/rotate`,
      data
    );
    toast.success("Uspešno rotirana slika");
    dispatch(fetchPropertyByRealId(propertyId));
    return res;
  } catch (err) {
    console.error(err);
    toast.error("Greška pri rotiranju slike");
    throw err;
  }
};

export const addSchemeImagesBulk = (values) => (dispatch) => {
  // VALUES JE TRENUTNO FILEARRAY ili tako nesto
  const bodyFormData = new FormData();
  const arr = Array.from(values);
  arr.forEach((entry) => {
    bodyFormData.append("images[]", entry);
  });

  return api
    .post(`${apiRoute}/properties/scheme/bulk`, bodyFormData)
    .then((res) => {
      dispatch({
        type: "ADD_ADMIN_IMAGES_PROPERTY",
        payload: res.data.data,
      });
      return res.data.data;
    })
    .catch((err) => {
      toast.error("Greska u dodavanju skica");
      throw err;
    });
};

export const addSchema = (id, values, codeId) => (dispatch) => {
  // VALUES JE TRENUTNO FILEARRAY ili tako nesto
  const bodyFormData = new FormData();
  const arr = Array.from(values);
  arr.forEach((entry) => {
    bodyFormData.append("images[]", entry);
  });
  return api
    .put(`${apiRoute}/properties/scheme/add/${id}`, bodyFormData)
    .then((res) => {
      toast.success("Uspesno dodate skice");
      dispatch({
        type: "ADD_ADMIN_IMAGES_PROPERTY",
        payload: res.data.data,
      });
      dispatch(fetchPropertyByRealId(codeId));
      return res;
    })
    .catch((err) => {
      toast.error("Greska u dodavanju skice");
      throw err;
    });
};

export const deleteSchema = (id, codeId) => (dispatch) => {
  return api
    .put(`${apiRoute}/properties/scheme/delete/${id}`)
    .then((res) => {
      toast.success("Uspešno izmenjena skica");
      dispatch(fetchPropertyByRealId(codeId));
      return res;
    })
    .catch((err) => {
      toast.error("Greska u izmeni skice");
      throw err;
    });
};

export const editImages = (id, values, codeId) => (dispatch) => {
  return api
    .put(`${apiRoute}/properties/images/${id}`, {
      pictures: values,
    })
    .then((res) => {
      toast.success("Uspesno izmenjene slike");
      dispatch({
        type: "ADD_ADMIN_IMAGES_PROPERTY",
        payload: res.data.data,
      });
      dispatch(fetchPropertyByRealId(codeId));
      return res;
    })
    .catch((err) => {
      toast.error("Greska u dodavanju slika");
      throw err;
    });
};

export const setAgentFilter = (value) => (dispatch) => {
  dispatch({
    type: "SET_AGENT_FILTER",
    payload: value,
  });
  return value;
};
